<div class="container-fluid" *ngIf="_routeService.formHideShow==0">
    <h2 class="heading_all">Route</h2>
    <br>
    <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4"></div>
        <div class="col-md-4 ">

            <table>
                <thead>
                    <tr>
                        <td>
                            <button type="button" class="btn-sm btn-info" (click)="addList()"><i class="fas fa-plus"
                                    aria-hidden="true"></i></button>
                        </td>
                        <td style="width: 70%;"><input type="text" class="form-control-search" name="search"
                                [(ngModel)]="term"></td>
                        <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                    </tr>
                </thead>
            </table>

        </div>
    </div>
    <br>
    <table>
        <thead>
            <tr>
                <th>#</th>
                <th class="hidden-xs">
                    <div class="AtjIsPoint" (click)="sort('RouteName')">
                        <span *ngIf="!_routeService.isFiltering">RouteName</span>
                        <div class="AtjfloatRight">
                            <i class="fas fa-sort" *ngIf="_routeService.orderByColName!='RouteName' "></i>
                            <div *ngIf="_routeService.orderByColName=='RouteName'">
                                <i class="fas fa-sort-amount-down" *ngIf="_routeService.orderByDir"></i>
                                <i class="fas fa-sort-amount-up-alt" *ngIf="!_routeService.orderByDir"></i>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="_routeService.isFiltering">
                        <input type="text" #txtRouteNameFilter="ngModel" [(ngModel)]="_routeService.RouteNameFilter"
                            placeholder="RouteName">
                    </div>

                </th>
                <th class="hidden-xs">
                    <div class="AtjIsPoint" (click)="sort('CountryId')">
                        <span *ngIf="!_routeService.isFiltering">Country</span>
                        <div class="AtjfloatRight">
                            <i class="fas fa-sort" *ngIf="_routeService.orderByColName!='CountryId' "></i>
                            <div *ngIf="_routeService.orderByColName=='CountryId'">
                                <i class="fas fa-sort-amount-down" *ngIf="_routeService.orderByDir"></i>
                                <i class="fas fa-sort-amount-up-alt" *ngIf="!_routeService.orderByDir"></i>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="_routeService.isFiltering">
                        <input type="text" #txtCountryIdFilter="ngModel" [(ngModel)]="_routeService.CountryIdFilter"
                            placeholder="CountryId">
                    </div>

                </th>
                <th><em></em> Settings
                    <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                        <i *ngIf="!_routeService.isFiltering" class="fas fa-filter"></i>
                        <i *ngIf="_routeService.isFiltering" class="fas fa-times"></i>
                    </a>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let modul of _routeService.allRoutes | orderBy : 'RouteName'| gridOperations  :_routeService.pageIndex: 
                        {RouteName:_routeService.RouteNameFilter,CountryId:_routeService.CountryIdFilter}:
                       {Column:_routeService.orderByColName,Dir:_routeService.orderByDir} ; let i = index"
                class="ng-scope">
                <td>{{i+1+((NoOfItems*_routeService.pageIndex)-NoOfItems)}}</td>
                <td>{{modul.RouteName}}</td>
                <td>{{modul.CountryName}}</td>
                <td>
                    <button type="button" class="btn-success" (click)="showForEdit(modul)">
                        <i class="fas fa-pen-square" aria-hidden="true"></i></button>
                    <button type="button" class="btn-danger" (click)="onDelete(modul)"><i class="fas fa-trash"
                            aria-hidden="true"></i></button>
                </td>
            </tr><!-- end ngRepeat: item in items -->
            <tr>
                <td colspan="3" *ngIf="(_routeService.allRoutes?.length<=0 )  || _CommonService.filterdItemCount<1">
                    No Records To
                    Display.</td>
            </tr>
        </tbody>
        <tfoot>
            <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                <app-grid-pagination (pageIndexValue)="_routeService.pageIndex=$event">
                </app-grid-pagination>
            </td>
        </tfoot>
    </table>
    <!-- <pagination-controls (pageChange)="p = $event"></pagination-controls> -->
    <div class="margintop"></div>
    <!-- </div>
    </div> -->
</div>
<app-delete-confirm *ngIf="deletePopUp" [title]="'Route'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>